import HttpStatus from 'http-status'

import { ApiError } from './types'

import Toast from 'common/components/toast/Toast'
import { Events } from 'common/types'

export default class ApiHelper {
  static errorHandling = (exceptionError: unknown, showToast = true) => {
    const error = exceptionError as ApiError
    const status = error?.response?.status

    const customEventsByError = {
      [HttpStatus.UNAUTHORIZED]: new CustomEvent(Events.LIVE_401_REQUEST_ERROR, { detail: error }),
      [HttpStatus.FORBIDDEN]: new CustomEvent(Events.LIVE_403_REQUEST_ERROR, { detail: error }),
      [HttpStatus.NOT_FOUND]: new CustomEvent(Events.LIVE_404_REQUEST_ERROR, { detail: error })
    }

    const customEvent = status ? customEventsByError[status] : void 0

    customEvent && window.dispatchEvent(customEvent)

    if (showToast && error?.response?.statusText) {
      Toast.danger(error.response.statusText)
    }

    return error
  }
}
